import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import useFetch from "../../../../../hooks/useFetch";
import { toast } from "react-toastify";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "change-password-form";

/**
 * Reset a student's password. forwardRef for the MUI <Modal> child ref. Fetch
 * wiring unchanged; only the shell and the submit affordance moved onto the
 * shared design system.
 */
const Password = forwardRef(({ close, Id }, ref) => {
  const [call, setCall] = useState({
    username: Id,
    new_password: "",
  });

  const newGroup = useFetch({
    method: "POST",
    url: `management/change-password/`,
    noHeader: false,
    trigger: false,
    data: call,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ values: call });

  const onSubmit = () => {
    newGroup.reFetch();
  };

  useEffect(() => {
    if (newGroup.status === 200) {
      close();
      toast.success("رمز عبور تغییر یافت.", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "light",
        rtl: true,
      });
    }
  }, [newGroup.status]);

  return (
    <ModalShell
      ref={ref}
      close={close}
      title="تغییر رمز عبور"
      subtitle="رمز جدید حداقل ۴ کاراکتر باشد"
      width="max-w-[44rem]"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={newGroup.loading}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {newGroup.loading ? "در حال ثبت…" : "ثبت رمز جدید"}
          </button>
        </div>
      }
    >
      {newGroup.error && <p role="alert" className="text-danger">{newGroup.error.message}</p>}
      <form id={FORM_ID} onSubmit={handleSubmit(onSubmit)} noValidate>
        <TextField
          type="password"
          label="رمز جدید"
          value={call.new_password}
          {...register("new_password", {
            required: "رمز را وارد کنید",
            minLength: { value: 4, message: "حداقل ۴ کاراکتر" },
          })}
          error={!!errors.new_password}
          helperText={errors.new_password?.message}
          onChange={(e) => setCall({ ...call, new_password: e.target.value })}
          fullWidth
        />
      </form>
    </ModalShell>
  );
});

export default Password;
